<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Stock Valuation
        <small>Total inventory value by category</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">Reports</a> /
        <span class="current">Stock Valuation</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-outline btn-sm" (click)="printPage()"><i class="bi bi-printer"></i> Print</button>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-coin" style="color:#f59e0b;"></i>
        <h2>Stock Valuation</h2>
        <span class="report-badge">{{ dateRange.appliedDayCount() }} days</span>
      </div>
    </div>
    <div class="report-body">
      <div class="valuation-summary">
        <div class="valuation-total">
          <span class="valuation-label">Total Inventory Value</span>
          <span class="valuation-amount">{{ formatCurrency(summary().totalValue) }}</span>
        </div>
        <div class="valuation-breakdown">
          @for (cat of categories(); track cat.category) {
            <div class="valuation-category">
              <span class="cat-name">{{ cat.category }}</span>
              <div class="cat-bar">
                <div class="cat-fill" [style.width.%]="categoryWidth(cat.value)" style="background:#D31F26;"></div>
              </div>
              <span class="cat-value">{{ formatCurrency(cat.value) }}</span>
            </div>
          }
        </div>
      </div>
      <div class="valuation-table-wrap">
        <table class="report-data-table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Item</th>
              <th>Category</th>
              <th>Qty</th>
              <th>Unit Cost</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items(); track item.itemCode) {
              <tr>
                <td>{{ item.itemCode }}</td>
                <td>{{ item.itemName }}</td>
                <td>{{ item.category }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ formatCurrency(item.unitCost) }}</td>
                <td>{{ formatCurrency(item.totalValue) }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
